


import { Component, Vue } from 'vue-property-decorator';
import Api from '../services/Api';
const alertify = require('alertifyjs');

@Component
export default class Soal extends Vue {
  private validasiMinimalJawab: boolean = true;
  private count: number = 0;
  private soalList: any[] = [];
  private soal: any[] = [];
  private pilihanA: any[] = [];
  private pilihanB: any[] = [];
  private pilihanC: any[] = [];
  private pilihanD: any[] = [];
  private pilihanE: any[] = [];
  private sisaWaktu: string = '';
  private sisa: number = 0;
  private mapel: string = '';
  private username: string = '';
  private counter: number = 0;
  spinner: boolean = false;
  private minDikerjakan: number = 0;
  private viewList: boolean = false;

  private apiService: Api = new Api();

  constructor() {
    super();
  }

  created() {
    const { sisa, mapel } = this.$route.params;
    if ( ! sisa) {
      this.apiService.postResource('/reset', {
        nomor: this.username
      }, true).then(r => {
        this.$router.replace({ path: '/' });
      }).catch(err => {
        this.$toast.error(err.status + ' - ' + err.statusText);
      });
      // // di by pass
      // console.log('bypassed');
      // this.selesai();
    }
    this.sisa = parseInt(sisa);
    if (this.sisa < 1) {
      this.selesai();
      return;
    }
    this.getSoal();
  }

  toggleList(): void {
    this.viewList = ! this.viewList;
  }
  goToSoal(i: number): void {
    this.viewList = false;
    this.counter = i;
    this.mapJawaban();
  }

  getSoal(): void {
    this.spinner = true;
    const username = localStorage.getItem('username');
    const mapel = localStorage.getItem('mapel');
    this.mapel = mapel ? mapel : '';
    this.username = username ? username : '';
    this.apiService.postResource('/soal', {
      username: username,
      mapel: mapel
    }, true).then(r => {
      this.spinner = false;
      if (r.err) {
        this.$toast.error(r.err);
      } else {
        this.soalList = r.data;
        this.count = this.soalList.length;
        this.checkJawaban(); // apakah server mengirim jawaban

        this.mapJawaban(); // map jawaban untuk soal pertama
        this.hitungMinimalJawaban();
        this.countDownTime();
      }
    }).catch(err => {
      console.log(err);
      this.spinner = false;
      this.$toast.error('GAGAL MEMUAT SOAL, MENCOBA DALAM 5 DETIK');
      setTimeout(() => {
        this.getSoal();
      }, 3000);
    });
  }

  prevSoal(): void {
    this.counter -= 1;
    this.mapJawaban();
  }
  nextSoal(): void {
    this.counter += 1;
    this.mapJawaban();
  }

  // cek jawaban sebelumnya jika sudah pernah menjawab
  // server akan memberi tahu apakah soal sudah dijawab dan
  // tersimpan di database
  checkJawaban(): void {
    for (const soal of this.soalList) {
      this.$set(soal, 'si', 0);
      this.$set(soal, 'st', '');
      this.$set(soal, 'sc', '');
      this.$set(soal, 'upload', 0);
      this.$set(soal, 'ragu', null);
      // jika sudah jawab, a terset
      if (soal.a) {
        const opsi = soal.o;
        // untuk essay
        soal.si = 1;
        soal.st = '-';
        soal.upload = 1;
        // untuk pilihan ganda
        for (let index = 1; index <= opsi.length; index++) {
          const item = opsi[index - 1];
          if (item.c == soal.a) {
            // ambil jawaban dan index
            soal.si = item.i;
            soal.upload = 1;
            let st = '';
            switch (index) {
              case 1: st = 'A'; break;
              case 2: st = 'B'; break;
              case 3: st = 'C'; break;
              case 4: st = 'D'; break;
              case 5: st = 'E'; break;
            }
            soal.st = st;
          }
        }
      }

      // apakah masuk ke array ragu
      const ragu = localStorage.getItem('ragu');
      if (ragu) {
        for (const i of JSON.parse(ragu)) {
          if (i == soal.i) {
            soal.ragu = 1;
          }
        }
      }
    }
  }

  getButtonClass(label: string, i: number): string {
    const si = this.soalList[this.counter].si;
    const up = this.soalList[this.counter].upload;
    const oi = this.soalList[this.counter].o[i].i;
    if (this.soalList[this.counter].ragu) {
      if (si == oi) {
        return up == 2 ? 'btn-danger' : 'btn-warning';
      }
    } else {
      if (si == oi) {
        return up == 2 ? 'btn-danger' : 'btn-success';
      }
    }
    return 'btn-secondary';
  }

  mapJawaban(): void {
    const soal = this.soalList[this.counter];
    this.pilihanA = soal.o[0];
    this.pilihanB = soal.o[1];
    this.pilihanC = soal.o[2];
    this.pilihanD = soal.o[3];
    this.pilihanE = soal.o[4];
  }

  pilihJawaban(pilihan: any, t: string, essay: any = null) {
    if (essay) {
      this.soalList[this.counter].si = essay;
      this.soalList[this.counter].sc = '-';
      this.soalList[this.counter].st = '-';
    } else {
      this.soalList[this.counter].si = pilihan.i;
      this.soalList[this.counter].sc = pilihan.c;
      this.soalList[this.counter].st = t;
    }
    // status upload
    const param = {
      username: this.username,
      mapel: this.mapel,
      soal: this.soalList[this.counter].i,
      jawab: this.soalList[this.counter].sc
    };
    this.soalList[this.counter].upload = 0;
    this.apiService.postResource('/jawab', param, true).then(r => {
      // console.log(this.soalList[this.counter]);
      this.soalList[this.counter].upload = 1;
    }).catch(err => {
      // trying to submit
      this.soalList[this.counter].upload = 2;
    });
  }

  hitungMinimalJawaban(): void {
    const dikerjakan = localStorage.getItem('dikerjakan');
    if (this.minDikerjakan == 0) {
      this.minDikerjakan = dikerjakan ? parseInt(dikerjakan) : 0;
    }
    if (this.minDikerjakan == 0) {
      this.minDikerjakan = this.soalList.length;
    }
  }

  // disabled
  // hitung yang sudah dikerjakan
  get terjawab(): number {
    let answered = 0;
    for (let i = 0; i < this.soalList.length; i++) {
      const s = this.soalList[i];
      if (s.st && s.upload == 1) {
        answered += 1;
      }
    }
    return answered;
  }

  konfirmasiSelesai(): void {
    alertify.confirm('Konfirmasi Tes!', 'Anda masih memiliki waktu untuk mengerjakan tes. <strong>Apakah anda yakin ingin mengakhiri tes ini?</strong>', () => this.selesai(), () => {});
  }

  selesai(): void {
    this.spinner = true;
    this.apiService.postResource('/selesai', {
      username: this.username, mapel: this.mapel
    }, true).then(r => {
      this.$router.replace({ path: 'nilai' });
    }).catch(err => {
      this.spinner = false;
      this.$toast.error('GAGAL MENGUMPULKAN SOAL! COBA LAGI');
    });
  }

  countDownTime(): void {
    let start = this.sisa;
    let i = setInterval(() => {
      const distance = start * 1000;
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      let tampung: string[] = [];
      if (hours > 0) {
        tampung.push((hours + '').padStart(2, '0'));
      } else {
        tampung.push('00');
      }
      if (minutes > 0) {
        tampung.push((minutes + '').padStart(2, '0'));
      } else {
        tampung.push('00');
      }
      if (seconds > 0) {
        tampung.push((seconds + '').padStart(2, '0'));
      } else {
        tampung.push('00');
      }
      this.sisaWaktu = tampung.join(':');
      start -= 1;

      if (distance < 0) {
        this.selesai();
        clearInterval(i);
      }
    }, 1000);
  }
}
